import type { Role } from "./types";

export type WorkspaceMembershipSummary = {
  roles: Role[];
  status: "active" | "suspended";
  clientAccess: { kind: "all" } | { kind: "selected"; companyIds: string[] };
};

const workspaceManagerRoles = new Set<Role>(["agency_admin", "account_manager"]);

export function canManageWorkspaceActions({
  companyId,
  memberships,
}: {
  companyId?: string;
  memberships?: WorkspaceMembershipSummary[] | null;
}): boolean {
  return Boolean(
    memberships?.some((membership) => {
      if (membership.status !== "active" || !membership.roles.some((role) => workspaceManagerRoles.has(role))) {
        return false;
      }

      if (!companyId) {
        return true;
      }

      return membership.roles.includes("agency_admin") || membership.clientAccess.kind === "all" || membership.clientAccess.companyIds.includes(companyId);
    }),
  );
}
